<template>
  <van-popup
    v-model:show="visible"
    :close-on-click-overlay="closeOnClickOverlay"
    :style="[vanPopupStyle]"
    teleport="body"
  >
    <div class="popup-view" :style="popupStyle">
      <div v-if="title && title !== null" class="popup-view__header">
        <p class="popup-view__header__title">{{ title }}</p>
      </div>
      <slot v-else name="header"></slot>
      <slot name="content"></slot>
    </div>

    <div v-if="closeable" class="close-container chxy-row-c-c" @click="closePopup">
      <van-icon name="close" size="32" color="#FFFFFF" />
    </div>
  </van-popup>
</template>

<script setup>
const visible = ref(false)

const props = defineProps({
  vanPopupStyle: { type: Object, default: () => {} },
  title: { type: String, default: '' },
  closeOnClickOverlay: { type: Boolean, default: false },
  padding: { type: [Number, String], default: 10 },
  radius: { type: [Number, String], default: 15 },
  background: { type: String, default: '#A4D5F5' },
  borderColor: { type: String, default: 'transparent' },
})

const popupStyle = computed(() => {
  return {
    padding: !isNaN(props.padding) ? `${props.padding}px` : props.padding,
    'background-color': props.background,
    'border-color': props.borderColor,
    'border-radius': `${props.radius}px`,
  }
})

const open = () => {
  visible.value = true
}

const close = () => {
  emit('close')
  visible.value = false
}

const emit = defineEmits(['close'])

defineExpose({ open, close })
</script>

<style scoped lang="scss">
:deep(.van-overlay) {
  background-color: rgba(0, 0, 0, 0.3) !important;
}
.popup-view {
  position: relative;
  width: 100%;
  border: 1px solid;
  overflow-y: visible;

  &__header {
    width: 100%;
    height: 24px;
    font-size: 16px;
    text-align: center;
    color: #ffffff;
    line-height: 24px;
  }
}
</style>
